exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "number-objective input {\r\n\twidth: 5rem;\r\n\t-webkit-appearance: textfield;\r\n\t-moz-appearance: textfield;\r\n\tappearance: textfield;\r\n}\r\n\r\nnumber-objective input::-webkit-inner-spin-button {\r\n\tdisplay: none;\r\n}\r\n", ""]);

